import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimgs from "../../../assets/mlLeftImg.png";
import rightimgs from "../../../assets/mlRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
// import mlBenefitsImg1 from "../../../assets/mlBenefitsImg1.png";
// import mlBenefitsImg2 from "../../../assets/mlBenefitsImg2.png";
// import mlBenefitsImg3 from "../../../assets/mlBenefitsImg3.png";
// import mlBenefitsImg4 from "../../../assets/mlBenefitsImg4.png";
// import mlBenefitsImg5 from "../../../assets/mlBenefitsImg5.png";
// import mlBenefitsImg6 from "../../../assets/mlBenefitsImg6.png";
// import mlBenefitsImg7 from "../../../assets/mlBenefitsImg7.png";
// import mlBenefitsImg8 from "../../../assets/mlBenefitsImg8.png";
// import mlBenefitsImg9 from "../../../assets/mlBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
// import mlFunActivitiesImg1 from "../../../assets/mlFunActivitiesImg1.png";
// import mlFunActivitiesImg2 from "../../../assets/mlFunActivitiesImg2.png";
// import mlFunActivitiesImg3 from "../../../assets/mlFunActivitiesImg3.png";
// import mlFunActivitiesImg4 from "../../../assets/mlFunActivitiesImg4.png";
// import mlFunActivitiesImg5 from "../../../assets/mlFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

const MachineLearningPortal = () => {
  const machinelearningpage = heroContent.machinelearningpage;

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "11",
      classes: "6",
      description:
        " ML Basics - Intro to data prep, supervised & unsupervised learning, deep & reinforcement learning.",
    },
    {
      title: "Module 2",
      activities: "11",
      classes: "6",
      description:
        " Supervised Learning - Learn regression, classification, decision trees, SVMs & neural networks.",
    },
    {
      title: "Module 3",
      activities: "9",
      classes: "5",
      description:
        " Unsupervised Learning - Master clustering, dimensionality reduction, anomaly detection & more.",
    },
    {
      title: "Module 4",
      activities: "7",
      classes: "4",
      description:
        "Deep Learning - Build CNNs, RNNs & generative models for complex data",
    },
  ];

  const benefitsData = [
    {
      title: "Master ML Basics",
      description:
        "Get started with key machine learning concepts and techniques.",
      icon: "Polymath-images/mlBenefitsImg1.png",
    },
    {
      title: "Build Predictive Models",
      description: "Create models that make accurate future predictions.",
      icon: "Polymath-images/mlBenefitsImg2.png",
    },
    {
      title: "Classify Real Data",
      description: "Use algorithms to label and organize data effectively.",
      icon: "Polymath-images/mlBenefitsImg3.png",
    },
    {
      title: "Explore Data Patterns",
      description: "Find trends and patterns in complex datasets.",
      icon: "Polymath-images/mlBenefitsImg4.png",
    },
    {
      title: "Choose Right Algorithms",
      description: "Pick the best-fit algorithm for different data types.",
      icon: "Polymath-images/mlBenefitsImg5.png",
    },
    {
      title: "Train Neural Networks",
      description: "Teach machines to learn from data using deep learning.",
      icon: "Polymath-images/mlBenefitsImg6.png",
    },
    {
      title: "Understand Core Stats",
      description: "Learn essential statistics for data analysis and ML.",
      icon: "Polymath-images/mlBenefitsImg7.png",
    },
    {
      title: "Visualize Insights",
      description: "Turn data into visual stories using charts and graphs.",
      icon: "Polymath-images/mlBenefitsImg8.png",
    },
    {
      title: "Make Smart Predictions",
      description: "Apply ML to solve problems and make data-driven decisions.",
      icon: "Polymath-images/mlBenefitsImg9.png",
    },
  ];
  const activitiesData = [
    {
      title: "Data Cleaning",
      image: "Polymath-images/mlFunActivitiesImg1.png",
    },
    {
      title: "Clustering",
      image: "Polymath-images/mlFunActivitiesImg2.png",
    },
    {
      title: "Data Classification",
      image: "Polymath-images/mlFunActivitiesImg3.png",
    },
    {
      title: "SVM",
      image: "Polymath-images/mlFunActivitiesImg4.png",
    },
    {
      title: "CNN",
      image: "Polymath-images/mlFunActivitiesImg5.png",
    },
  ];

  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
      leftImg={'Polymath-images/mlLeftImg.png'}
      rightImg={'Polymath-images/mlRightImg.png'}
      titlePart1="Machine Learning"
      titlePart2="Course"
      description="Polymath-kids offer comprehensive online Machine Learning course for kids aged 14 to 18 year. The online classes’ offers two modes –online 1:1 classes and online group classes with trained teachers having years of experience in Computer Sciences."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        modules={beginnerModules}
      />
      <Benefits
        title="How Students Can Benefit From Machine Learning"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn Machine Learning"
        subTitle="With 30+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default MachineLearningPortal;
